import features from '@nobia/zeus-components/lib/features'

const scrollTo = ref => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  setTimeout(
    () =>
      window.scrollTo({
        left: 0,
        top: ref && ref.getBoundingClientRect().top + scrollTop - 110,
        behavior: 'smooth',
      }),
    400
  )
}

/* eslint no-useless-escape: 0 */
const cloudinaryUrlTransformation = (data, transformation, friendlyurl) => {
  const image = JSON.parse(data)
  const host = 'https://res.cloudinary.com/dgg9enyjv/'
  let transformations = `${transformation}`
  const resourceType = image.resourceType ? image.resourceType : 'image'

  if (image.transformations.length > 0)
    transformations = `${image.transformations}/${transformation}`

  if (friendlyurl.length > 0)
    return `${host}${resourceType}s/${transformations}/v${image.version}/${image.publicId}/${friendlyurl}`

  return `${host}${resourceType}/${image.type}/${transformations}/v${image.version}/${image.publicId}`
}

const galleryListTransformation = (data, width) => {
  const image = JSON.parse(data)

  if (image.width < image.height) {
    return `c_fill,ar_101:140,q_auto:best,${width}`
  }
  return `c_fill,ar_101:65,q_auto:best,${width}`
}

const createModalHtml = data =>
  data.images.expandedValue.map(imageData => {
    const image = JSON.parse(imageData.image.value)

    let windowHeight = 0

    if (typeof window !== 'undefined') {
      windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
    }

    let height = 0
    let width = 0

    if (windowHeight > 1158) {
      width = 2500
      if (image.width < image.height) {
        height = 3465
      } else {
        height = 1609
      }
    } else {
      width = 1800
      if (image.width < image.height) {
        height = 2495
      } else {
        height = 1158
      }
    }

    if (image.resourceType === 'video') {
      return {
        html: `<video controls playsinline autoplay>
        <source
          src=${cloudinaryUrlTransformation(
            imageData.image.value,
            `c_fill,w_${width},h_${height},q_auto:best`,
            imageData.friendlyFileName.value
          )}
        />`,
        w: width,
        h: height,
        title: imageData.title,
        pid: imageData.contentLink.id,
        gid: data.contentLink.id,
      }
    }
    return {
      src: cloudinaryUrlTransformation(
        imageData.image.value,
        galleryListTransformation(imageData.image.value, `w_${width}`),
        imageData.friendlyFileName.value
      ),
      thumbnail: cloudinaryUrlTransformation(
        imageData.image.value,
        galleryListTransformation(imageData.image.value, 'w_200'),
        imageData.friendlyFileName.value
      ),
      msrc: cloudinaryUrlTransformation(
        imageData.image.value,
        galleryListTransformation(imageData.image.value, 'w_200'),
        imageData.friendlyFileName.value
      ),
      w: features.fullScreen ? 'auto' : width,
      h: height,
      title: imageData.title,
      pid: imageData.contentLink.id,
      gid: data.contentLink.id,
    }
  })

export {
  scrollTo,
  cloudinaryUrlTransformation,
  createModalHtml,
  galleryListTransformation,
}
